export default "__VITE_ASSET__BS3sn1vD__"